import { render, staticRenderFns } from "./EditDescriptionModal.vue?vue&type=template&id=4fb43037&scoped=true&"
import script from "./EditDescriptionModal.vue?vue&type=script&lang=js&"
export * from "./EditDescriptionModal.vue?vue&type=script&lang=js&"
import style0 from "./EditDescriptionModal.vue?vue&type=style&index=0&id=4fb43037&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb43037",
  null
  
)

export default component.exports